const normalizePath = (path: string) => {
	const [pathname] = path.split(/[?#]/);
	if (pathname === "/") {
		return pathname;
	}

	return pathname.replace(/\/+$/, "");
};

export const isNavPathActive = (pathname: string, navPath: string) => {
	const currentPath = normalizePath(pathname);
	const targetPath = normalizePath(navPath);

	if (!targetPath) {
		return false;
	}

	if (targetPath === "/") {
		return currentPath === "/";
	}

	return (
		currentPath === targetPath || currentPath.startsWith(`${targetPath}/`)
	);
};
